import React, { useEffect, useState } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { getTenantDisplayName, labelsHaveChanges, normalizeLabels } from '../tenantHelpers';

const ManageLabelsModal = ({ tenant, labelSuggestions, isOpen, onClose, onSave, isSaving, error }) => {
  const [labels, setLabels] = useState([]);
  const [originalLabels, setOriginalLabels] = useState([]);
  const [newLabel, setNewLabel] = useState('');

  useEffect(() => {
    if (tenant) {
      const initial = normalizeLabels(tenant.labels || []);
      setLabels(initial);
      setOriginalLabels(initial);
      setNewLabel('');
    }
  }, [tenant, isOpen]);

  if (!isOpen || !tenant) return null;

  const addLabel = (value = newLabel) => {
    const label = String(value || '').trim();
    if (!label) return;
    if (labels.some((item) => item.toLowerCase() === label.toLowerCase())) return;
    setLabels((prev) => [...prev, label]);
    setNewLabel('');
  };

  const removeLabel = (label) => {
    setLabels((prev) => prev.filter((item) => item !== label));
  };

  const suggestions = (labelSuggestions || [])
    .filter((label) => !labels.some((item) => item.toLowerCase() === label.toLowerCase()))
    .slice(0, 8);

  const hasChanges = labelsHaveChanges(originalLabels, labels);

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>Manage labels</h2>
            <p>{getTenantDisplayName(tenant)}</p>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} disabled={isSaving} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <p className="stm-modal__label">Current labels</p>
          <div className="stm-label-editor">
            {labels.length ? labels.map((label) => (
              <button key={label} type="button" className="stm-label-editor__chip" onClick={() => removeLabel(label)}>
                {label}
                <FaTimes aria-hidden />
              </button>
            )) : (
              <span className="stm-muted">No labels</span>
            )}
          </div>
          <div className="stm-label-editor__add">
            <input
              value={newLabel}
              onChange={(event) => setNewLabel(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  addLabel();
                }
              }}
              placeholder="Add label"
              disabled={isSaving}
            />
            <button type="button" className="stm-icon-btn" onClick={() => addLabel()} disabled={isSaving}>
              <FaPlus />
            </button>
          </div>
          {suggestions.length > 0 && (
            <div className="stm-label-suggestions">
              {suggestions.map((label) => (
                <button key={label} type="button" onClick={() => addLabel(label)} disabled={isSaving}>{label}</button>
              ))}
            </div>
          )}
          {error && <p className="stm-field-error">{error}</p>}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--secondary" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button
            type="button"
            className="stm-btn stm-btn--primary"
            disabled={isSaving || !hasChanges}
            onClick={() => onSave(normalizeLabels(labels))}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ManageLabelsModal;
